<form [formGroup]="userForm" (ngSubmit)="updateOrCreateUser()" ngNativeValidate>
  @if (!editMode) {
    <h2 mat-dialog-title>Benutzer hinzufügen</h2>
  }
  @if (editMode) {
    <h2 mat-dialog-title>Benutzer editieren</h2>
  }
  <mat-dialog-content>
    <div>
      <mat-form-field>
        <mat-label>E-Mail</mat-label>
        <input matInput formControlName="email" required />
        @if (userForm.controls.email.hasError('required')) {
          <mat-error
            >Feld wird benötigt</mat-error
            >
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Vorname</mat-label>
          <input matInput formControlName="firstName" required />
          @if (userForm.controls.firstName.hasError('required')) {
            <mat-error
              >Feld wird benötigt</mat-error
              >
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Nachname</mat-label>
            <input matInput formControlName="lastName" required />
            @if (userForm.controls.lastName.hasError('required')) {
              <mat-error
                >Feld wird benötigt</mat-error
                >
              }
            </mat-form-field>

            <mat-checkbox formControlName="admin"> Administrator </mat-checkbox>
            @if (userForm.controls.admin.hasError('required')) {
              <mat-error
                >Feld wird benötigt</mat-error
                >
              }
            </div>
          </mat-dialog-content>

          <mat-dialog-actions align="end">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="!userForm.valid"
              >
              @if (!data?.id) {
                Benutzer anlegen
              }
              @if (data?.id) {
                Speichern
              }
            </button>
            @if (editMode) {
              <button
                type="button"
                mat-raised-button
                (click)="resetPassword()"
                >
                Passwort zurücksetzen
              </button>
            }
            @if (editMode) {
              <button
                type="button"
                mat-raised-button
                (click)="deleteUser()"
                >
                Benutzer löschen
              </button>
            }
            <button mat-raised-button [mat-dialog-close]="true">Schließen</button>
          </mat-dialog-actions>
        </form>
